
import Big from 'big.js'
import CodeHelpers from './CodeHelpers.js'
import ParseType from './ParseType.js'

function ParseDeclarations (parser) {
    this.parser = parser
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.scanner = parser.scanner
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
    this.outline = parser.outline
}

ParseDeclarations.prototype = {
    parse (displ) {
        let codeHelpers = new CodeHelpers(this.parser)
        if (this.hintHelper) {
            this.hintHelper.checkTokensForHints([this.SC.K_DEFINE])
        }
        while (this.parser.scanner.nextIs(this.SC.K_DEFINE)) {
            this.parserDeclaration()

            if (this.hintHelper) {
                this.hintHelper.checkTokensForHints([this.SC.K_DEFINE])
            }
        }
        if (this.parser.compile) {
            codeHelpers.codeAllocateVars(displ)
        }
    },
    parserDeclaration () {
        let currentIdent
        let variables = []
        let identIsArray
        let declarationType
        let expectedToken
        let size
        let readIdent = true
        let parseType = new ParseType(this.parser)

        this.parser.expect(this.SC.K_DEFINE)

        while (readIdent) {
            currentIdent = this.parser.expect(this.SC.IDENT)
            if (currentIdent !== false) {
                if (this.parser.isKeyword(currentIdent.lexema)) {
                    this.parser.error(currentIdent, 'La palabra ' + currentIdent.lexema + ' es una palabra reservada del lenguaje y no puede utilizarse aquí.')
                }
                identIsArray = false
                size = 0
                if (this.scanner.nextIs(this.SC.INDEX_SEL_OPEN)) {
                    identIsArray = true
                    this.parser.expect(this.SC.INDEX_SEL_OPEN)
                    size = this.parser.expect(this.SC.CONS_INT)
                    if (size === false) {
                        size = {
                            lexema: new Big(1)
                        }
                    } else if (size.lexema.eq(0)) {
                        this.parser.error(size, 'El tamaño del arreglo debe ser mayor a cero.')
                    }
                    this.parser.expect(this.SC.INDEX_SEL_CLOSE)
                }
                variables.push({
                    ident: currentIdent,
                    isArray: identIsArray,
                    size: size
                })
            }
            if (this.scanner.nextIs(this.SC.COMMA)) {
                this.parser.expect(this.SC.COMMA)
            } else {
                readIdent = false
            }
        }

        expectedToken = this.parser.expect(this.SC.K_AS)
        if (this.parser.hintHelper && currentIdent !== false && expectedToken === false) {
            this.parser.hintHelper.checkTokensForHints([this.SC.K_AS], ';\n\t', [this.SC.K_INT, this.SC.K_FLOAT, this.SC.K_CHAR, this.SC.K_BOOL])
        }

        declarationType = parseType.parse()

        for (let variable of variables) {
            if (this.stable.hasVariable(variable.ident.lexema)) {
                this.parser.error(variable.ident, 'La variable ' + variable.ident.lexema + ' ya está definida.')
            } else if (this.stable.hasParameter(variable.ident.lexema)) {
                this.parser.error(variable.ident, 'Ya existe un parámetro con el nombre ' + variable.ident.lexema)
            } else if (this.stable.hasCallable(variable.ident.lexema)) {
                this.parser.error(variable.ident, 'No puede haber una variable con el mismo nombre que el de un sub proceso o función.')
            } else {
                let varType = declarationType.clone()
                if (variable.isArray) {
                    varType.setAsArray()
                    varType.setSize(parseInt(variable.size.lexema.toString()))
                }
                this.stable.addVariable(variable.ident.lexema, varType, variable.ident)
                this.outline[this.parser.currentProcName].variables[variable.ident.lexema] = {
                    type: varType.clone(),
                    displacement: 0
                }
            }
        }

        this.parser.expect(this.SC.SEMICOLON)
    }
}

export default ParseDeclarations



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseDeclarations.js